import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { AzureAD } from 'react-aad-msal'
import { authProvider } from '../../services/authProvider'
import store from '../../store/configureStore'
import {
  fetchReportCompanyList,
  reportingCompanySelected,
  reportDateChanged,
  fetchBackupRecons,
} from '../actions/backup365ReportsActions'
import LoadingSpinner from '../Shared/LoadingSpinner'
import PageContainer from '../Shared/LayoutComponents/PageContainer'
import PageHeading from '../Shared/LayoutComponents/PageHeading'
import { Container, Row, Col, Card, CardBody, Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap'
import classnames from 'classnames'

import CompanyReportsTab from './Tabs/CompanyReportsTab'
import BackupReconsTab from './Tabs/BackupReconsTab'

const Backup365Reports = () => {
  const dispatch = useDispatch()
  const [activeTab, setActiveTab] = useState('company')

  useEffect(() => {
    ;(async () => {
      await dispatch(fetchReportCompanyList())

      await dispatch(fetchBackupRecons())
    })()
  }, [dispatch])

  const loading = useSelector((state) => state.backup365Reports.loading)

  return (
    <AzureAD provider={authProvider} reduxStore={store}>
      {({ accountInfo }) => {
        const roles = accountInfo?.account?.idToken?.roles || []
        const isAdminOrSales = roles.includes('Admin') || roles.includes('Sales')

        return (
          <PageContainer>
            <Container fluid className="mt-3 mb-4">
              <Row className="align-items-center mb-4">
                <Col>
                  <PageHeading>Backup 365 Reports</PageHeading>
                </Col>
              </Row>

              {/* Tabs */}
              <Nav tabs>
                <NavItem>
                  <NavLink
                    className={classnames({ active: activeTab === 'company' })}
                    onClick={() => setActiveTab('company')}
                    style={{ cursor: 'pointer' }}
                  >
                    Company Details
                  </NavLink>
                </NavItem>

                {isAdminOrSales && (
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === 'recons' })}
                      onClick={() => setActiveTab('recons')}
                      style={{ cursor: 'pointer' }}
                    >
                      Backup Reconciliations
                    </NavLink>
                  </NavItem>
                )}
              </Nav>

              <TabContent activeTab={activeTab} className="mt-4">
                <TabPane tabId="company" unmountOnExit={false}>
                  {!loading ? <CompanyReportsTab /> : <LoadingSpinner />}
                </TabPane>

                {isAdminOrSales && (
                  <TabPane tabId="recons" unmountOnExit={false}>
                    <BackupReconsTab />
                  </TabPane>
                )}
              </TabContent>
            </Container>
          </PageContainer>
        )
      }}
    </AzureAD>
  )
}

export default Backup365Reports
